// Some request URLs to the api
export const baseURL = process.env.VUE_APP_BASE_URL
export const googleMapsUrl = 'https://www.google.com/maps/place/'
export const loginURL = baseURL + 'login'
export const registerUrl = baseURL + 'user/register'
export const requestPasswordResetURL = baseURL + 'user/requestpasswordreset'
export const checkIDURL = baseURL + 'user/checkpasswordresetid'
export const passwordResetURL = baseURL + 'user/resetpassword'
export const emailCheck = baseURL + 'user/checkemail'
export const confirmUrl = baseURL + 'user/verify'
export const logoutURL = baseURL + 'logout'
export const versionURL = baseURL + 'version'
export const userID = baseURL + 'directory/iam'
export const user = baseURL + 'directory/name'
export const allUsers = baseURL + 'user/all'
export const deleteUserURL = baseURL + 'user'
export const updateUserURL = baseURL + 'user'
export const stationURL = baseURL + 'station'
export const parking = baseURL + 'station'
export const inRange = baseURL + 'station/search'
export const sitepresenceActivities = baseURL + 'sitepresence/predefinedactivities'
export const createSitepresence = baseURL + 'sitepresence/create'
export const checkSitepresenceUrl = baseURL + 'sitepresence/check'
export const endSitepresenceUrl = baseURL + 'sitepresence/end'
export const countAlarmsUrl = baseURL + 'sbcapi/count_alarms'
export const stationByCode = baseURL + 'station'
export const webcamByCode = baseURL + 'station'
export const routeByCode = baseURL + 'station'
export const postFeedback = baseURL + 'email/send'

export const disclaimer = baseURL + 'disclamer'
export const urlEncoded = 'application/x-www-form-urlencoded'
export const explicitHeader = { headers: { 'Content-Type': 'application/json; charset=UTF-8' } }

export const isSBCGoLightAdmin = baseURL + 'privileges/sbcgolightadmin'
export const regexURL = baseURL + 'user/regex'
export const reVerificationURL = baseURL + 'user/requestreverification'
